// extracted by mini-css-extract-plugin
export var contained = "OneThirdContentTiles-module--contained--b3218";
export var onethirdcontenttiles = "OneThirdContentTiles-module--onethirdcontenttiles--42d40";